import { CustomerDetails } from "src/features/hq/customers/models";
import { ConnectionName } from "./connection";

export type Account = CustomerDetails;

export type IdNameModel<T = string> = {
  id: T,
  name: string;
}

export interface LabeledValue<T = any> {
  label: string;
  value: T;
}

export type ServiceArtistModel = {
  networkName: ConnectionName;
  account: IdNameModel;
}

export type ChangePasswordForm = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export type FormItem<T> = {
  label: string;
  name: keyof T;
  value?: string;
}

export type Follower = ServiceArtistModel & {
  byCountry: ByCountry;
};

export type FirstRecord = ServiceArtistModel & {
  record: SongRecord;
  failReason: string;
}

export type SongRecord = {
  name: string;
  publishedAt: Date;
}

export type SocialFollower = Follower & {
  total: number;
  totalLastWeek: number;
};

export type ChartDatum = {
  label: string;
  value: number;
};

export type ChartDataContainer = {
  labels: string[];
  data: number[];
}

export type ChartData = ServiceArtistModel & ChartDataContainer;

export type FollowersByCountry = {
  networkName?: string;
  byCountry: ByCountry,
  totalByCountry: number;
};

export type ByCountry = Record<string, number>;

export enum Roles {
  Admin = "Admin",
  TestUser = "Test-User",
  Ambassador = "Ambassador"
}

export type DeepPartial<T> = T extends object ? {
  [P in keyof T]?: DeepPartial<T[P]>;
} : T;